import React from 'react';

import StyledIcon from './style';

const Icon = ({ name, color, size, align, ...props }) => (
	<StyledIcon
		className='icon'
		$name={name}
		$color={color}
		$size={size}
		$align={align}
		{...props}
	/>
);

export default Icon;
